export const JOB_TITLES = [
  { labelKey: 'jobTitles.contentCreator', value: 'content-creator' },
  { labelKey: 'jobTitles.clippingChannel', value: 'clipping-channel' },
  { labelKey: 'jobTitles.serviceProvider', value: 'service-provider' },
  { labelKey: 'jobTitles.brand', value: 'brand' },
] as const;

export type JobTitleValue = typeof JOB_TITLES[number]['value'];
